export default "__VITE_ASSET__2ec8ab5d__"